import { Button, ButtonSizes } from "@roc-digital/ui-web";
import { CommentItem } from "./CommentItem";
import { Comment } from "@roc-digital/types";
import React from "react";

interface CommentListProps {
  comments: Comment[];
  focusId?: number;
  canPageDown?: boolean;
  canPageUp?: boolean;
  loading?: boolean;
  loadingUp?: boolean;
  loadingDown?: boolean;
  loaded?: boolean;
  onPageDown: () => void;
  onPageUp: () => void;
  onEdit: (comment: Comment) => void;
  renderRepliesComponent?: (props: {comment: Comment, triggerNewReply?: number}) => any;
}

export function CommentList(props: CommentListProps) {

  const items = React.useMemo(() => {
    return props.comments.map(c => (
      <CommentItem key={c.id}
        comment={c}
        highlight={c.id === props.focusId}
        onEdit={props.onEdit}
        renderRepliesComponent={props.renderRepliesComponent}
      />
    ))
  }, [props.comments, props.focusId])

  React.useLayoutEffect(() => {
    if(!props.focusId || scrolledItems[props.focusId]) return;
    if(!props.comments.length) return;
    const e = document.getElementById('comment_'+props.focusId);
    if(!e) return;
    e.scrollIntoView();
    scrolledItems[props.focusId] = true;
  }, [props.comments, props.focusId]);

  return <div className="flex flex-col gap-2">

  {props.canPageUp ? (
    <div className="flex flex-row justify-center">
      <Button
        size={ButtonSizes.medium}
        clickEvent={props.onPageUp}
        customClassName="rounded-lg h-[42px]">Load More</Button>
    </div>
  ) : null}

  {props.loading && items.length ? (
    <div className="flex flex-row justify-center font-italic font-medium text-[12px] text-[#545454]">
      ...loading comments
    </div>
  ) : null}

  {items}

  {props.loadingDown ? (
    <div className="flex flex-row justify-center font-italic font-medium text-[12px] text-[#545454]">
      ...loading comments
    </div>
  ) : null}

  {!props.loading && props.loaded && !props.comments.length ? (
    <div className="flex flex-row justify-center font-italic font-medium text-[12px] text-[#545454]">
      No comments. Be the first to share something.
    </div>
  ) : null}

  {props.canPageDown ? (
    <div className="flex flex-row justify-center">
      <Button
        size={ButtonSizes.medium}
        clickEvent={props.onPageDown}
        customClassName="rounded-lg h-[42px]">Load More</Button>
    </div>
  ) : null}
</div>
}

const scrolledItems = {} as any;